import logger from './logger';
/**
 * Maps reportType from negotiation object to runtype
 * @param {string} reportType - The reportType from the negotiation object
 * @returns {string} - The mapped runtype value
 */
export const mapRuntype = (reportType) => {
  if (reportType === 'standard' || reportType === 'evidence_comparison') {
    return 'Unequal';
  }
  
  if (reportType === 'Assessment' || reportType === 'assessment') {
    return 'Excessive';
  }
  
  logger.log('Unmapped reportType:', reportType);
  return reportType;
};

